import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Breadcrumbs as MCBreadcrumbs,
  Anchor,
  Group,
  ActionIcon,
  Text,
} from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const SEGMENT_LABELS = {
  corral: "Corral",
  homepage: "Home",
  arboretum: "Arboretum",
  constellation: "Constellation",
  "magic-item": "Magic Items Inventory",
};

const Breadcrumbs = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const segments = pathname.split("/").filter(Boolean);

  const crumbs = segments.reduce((acc, seg, idx) => {
    const to = "/" + segments.slice(0, idx + 1).join("/");
    const label = SEGMENT_LABELS[seg] ?? decodeURIComponent(seg);

    if (idx === 0 && seg === "corral") {
      return [{ name: label, to }];
    }

    acc.push({ name: label, to });
    return acc;
  }, []);

  const capitalize = (s) =>
    typeof s === "string" && s.length
      ? s.charAt(0).toUpperCase() + s.slice(1)
      : s;

  const items = crumbs.map((crumb, i) => {
    const last = i === crumbs.length - 1;
    const label = capitalize(crumb.name);

    if (last || crumb.name === "Constellation" || crumb.name === "seed") {
      return <Text key={crumb.to}>{label}</Text>;
    } else {
      return (
        <Anchor component={Link} to={crumb.to} key={crumb.to}>
          {label}
        </Anchor>
      );
    }
  });

  let backButton = null;
  if (window.history.length > 1) {
    backButton = (
      <ActionIcon
        variant="subtle"
        onClick={() => navigate(-1)}
        aria-label="Back"
        size="sm"
      >
        <FontAwesomeIcon icon={faArrowLeft} />
      </ActionIcon>
    );
  }

  return (
    <Group spacing="xs">
      {backButton}
      <MCBreadcrumbs>{items}</MCBreadcrumbs>
    </Group>
  );
};

export default Breadcrumbs;
